import type { CSSProperties, ElementType, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Grid.module.css';

export type GridVariant =
  /** Fila de beneficios: 2 col en movil, 4-5 en escritorio (doc 03). */
  | 'features'
  /** Auto-ajustable sin desbordes: tarjetas de anchura minima 18rem. */
  | 'auto'
  /** Dos columnas asimetricas (imagen + texto) que apilan en movil. */
  | 'split'
  /** Tres columnas iguales que apilan en movil (zona baja de Bogota). */
  | 'thirds';

export interface GridProps {
  children: ReactNode;
  variant?: GridVariant;
  gap?: 'sm' | 'md' | 'lg' | 'fluid';
  /** Invierte el orden visual del `split` en escritorio (imagen a la derecha). */
  reverse?: boolean;
  as?: ElementType;
  className?: string;
  style?: CSSProperties;
}

/**
 * Rejillas del sistema. Todas apilan en movil manteniendo el ORDEN DE LECTURA
 * del DOM (ADR-005 §2.6): nunca se reordena con `order` de forma que el lector
 * de pantalla lea otra cosa que la vista.
 */
export function Grid({
  children,
  variant = 'auto',
  gap = 'fluid',
  reverse = false,
  as: Tag = 'div',
  className,
  style,
}: GridProps) {
  return (
    <Tag
      className={cx(styles.grid, styles[variant], styles[`gap-${gap}`], reverse && styles.reverse, className)}
      style={style}
    >
      {children}
    </Tag>
  );
}
